import { TypedEventTarget } from './abstract/TypedEventTarget';

export type DataTableFilterEvents = {
    filter: CustomEvent<string>;
};

export class DataTableFilter extends TypedEventTarget<DataTableFilterEvents> {
    private readonly filterInput?: HTMLInputElement;
    private readonly filterSelects: HTMLSelectElement[];

    constructor(private readonly form: HTMLFormElement) {
        super();

        const { searchParams } = new URL(location.href);
        const urlFilter = searchParams.get('filterDealer');
        const urlCountry = searchParams.get('countries');
        const urlDownload = searchParams.get('download');
        const downloadFilter = searchParams.get('filterDownload');

        this.form.addEventListener('submit', (event) => event.preventDefault());
        this.filterInput = Array.from(this.form.elements).find((element) => element instanceof HTMLInputElement) as
            | HTMLInputElement
            | undefined;
        this.filterSelects = Array.from(this.form.elements).filter(
            (element) => element instanceof HTMLSelectElement
        ) as HTMLSelectElement[];

        Array.from(this.form.elements).forEach((select) =>
            select.addEventListener('input', () => {
                this.onSelectValueChange(select as HTMLSelectElement);
            })
        );

        this.form?.closest('.frame')?.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
        });

        if (urlFilter || urlCountry || urlDownload || downloadFilter) {
            this.setFilter((urlFilter || urlCountry || urlDownload || downloadFilter) as string);
        }
    }

    setFilter(value: string) {
        const event = new CustomEvent('filter', { detail: value });

        if (this.filterInput) {
            this.filterInput.value = value;
        }
        this.filterSelects.forEach((select) => (select.value = value));

        requestAnimationFrame(() => this.dispatchEvent(event));
    }

    private onSelectValueChange(select: HTMLSelectElement) {
        if (select.type !== 'text') {
            this.filterSelects.forEach((field) => {
                if (field !== select) {
                    field.value = '';
                }
            });

            let filterBy = 'filterCountries';
            if (select.id === 'dealer-selector-continent') {
                filterBy = 'filterContinents';
            }

            const dataRows = Array.from(document.querySelectorAll<HTMLElement>('[data-row]'));
            const filteredElements = dataRows.filter((row) => row.dataset[filterBy]?.includes(select.value));

            const visibleSet = new Set(filteredElements);
            dataRows.forEach((row) => {
                row.style.display = visibleSet.has(row) ? '' : 'none';
            });
        } else {
            const dataRows = Array.from(document.querySelectorAll<HTMLElement>('[data-row]'));
            dataRows.forEach((row) => {
                row.removeAttribute('style');
            });

            this.setFilter(select.value);
        }
    }
}
